<template>
    <!--
            作者：peng
            时间：2020-08-11
            描述：商品组件
        -->
    <div>
        <!-- 遮罩层 -->
        <div style="width: 1200px;height: 650px;position: fixed;left: 0;right: 0;margin: 0 auto;z-index: 100;background-color: white;top: 150px;">
            <div style="width: 100%;height: 100%;background:gray;position:fixed;top:0;left:0;z-index:50;opacity:0.6;"></div>
        </div>
        <div style="width: 1200px;height: 650px;position: fixed;left: 0;right: 0;margin: 0 auto;z-index: 100;background-color: white;padding: 0 30px 30px 30px;top: 150px;">
            <div style="width: 100%;height: 80px;line-height: 80px;">
                <h1 style="float: left;">选择商品</h1>
                <a @click="close()" style="float: right;font-size: 20px;">x</a>
            </div>
            <!-- 表单 -->
            <div>
                <div class="common-seach-wrap">
                    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="商品分类">
                            <el-select v-model="formInline.categoryID" placeholder="请选择商品分类">
                                <el-option label="全部" value="-1"></el-option>
                                <el-option v-for="(item,index) in categoryID" :key="index" :label="item" :value="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品名称"><el-input v-model="formInline.productName" placeholder="请输入商品名称"></el-input></el-form-item>
                        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
                    </el-form>
                </div>
            </div>
            <!-- 表格 -->
            <div class="product-content">
                <div class="table-wrap">
                    <el-table size="small" :data="productList" border style="width: 100%" highlight-current-row v-loading="loading">
                        <el-table-column width="70" label="商品图片">
                            <template slot-scope="scope">
                                <img :src="scope.row.file_url + '/' + scope.row.file_name" width="30" height="30" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="product_name" label="商品名称"></el-table-column>
                        <el-table-column prop="name" width="100" label="商品分类"></el-table-column>
                        <el-table-column prop="create_time" width="140" label="添加时间"></el-table-column>
                        <el-table-column type="selection" :selectable="selectableFunc" width="44"></el-table-column>
                    </el-table>
                </div>

                <!--分页-->
                <div class="pagination">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            background
                            :current-page="curPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next, jumper"
                            :total="totalDataNumber"
                    ></el-pagination>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import SignadvApi from '@/api/signadv.js';
    export default {
        data() {
            return{
                /* 表单数据 */
                formInline:{},
                /* 商品分类 */
                status:{},
                /* 表格数据 */
                productList:{},
                loading: true,
                /*一页多少条*/
                pageSize: 5,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                categoryID:[],
            };
        },
        created() {
            this.getList();
            this.categoryList();
        },
        methods: {
            /* 关闭弹窗 */
            close(){
                this.$parent.fatherClose();
            },
            /* 商品分类 */
            categoryList(){
                let self = this;
                SignadvApi.categoryList('',true)
                    .then(data => {
                        console.log(data)
                        self.loading = false;
                        self.categoryID = (data.data.list[0]);
                        console.log(self.categoryID)
                    })
                    .catch(error => {
                        self.loading = false;
                    })
            },
            /* 商品列表 */
            getList(){
                let self = this;
                let Params = self.formInline;
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                SignadvApi.productList(Params,true)
                    .then(data => {
                        console.log(data)
                        self.loading = false;
                        self.productList = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch(error => {
                        console.log(error)
                        self.loading = false;
                    });
            },
            /* 查询 */
            onSubmit(){
                let self = this;
                self.loading = true;
                let Params = self.formInline;
                self.getList();
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getList();
            },
            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getList();
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/signadv/Getsignadv.vue